<template>
<div class="container-fluid">

 <!-- Modal MESSAGE -->  
 <modalMessage ref="msgModal"/>

<div>


<div class="card border-primary" >
  <div class="card-header bg-primary text-white">
    <h4><i style="color:#FFCC00" class="far fa-list-alt mr-3"></i>
    LISTA DOCUMENTI FORNITORI
  </h4>
  </div>
  <div class="card-body text-primary">

     <div class="ml-3 mt-1 mb-1 mr-3">
          <label for="customRange3"><strong>ULTIMI
          <span  class="badge badge-pill badge-primary">{{ range }}</span>
          DOCUMENTI</strong> 
        </label>
        <input @change="getData()" type="range" class="custom-range" min="100" max="500" step="100" id="customRange" v-model="range">

        </div>

    <div class="row">
    <div class="col">
    <div class="table-wrapper-scroll-y my-custom-scrollbar ">              
  <table class="table table-sm table-hover  mb-0" id="table">
    <thead >
      <tr class="table-primary">
        <th>
         # 
        </th>  
        <th>
         FORNITORE
        </th>  
        <th class="text-right text-nowrap">
        TOTALE Q.TA'
        </th>
        <th class="text-right text-nowrap">
        TOTALE €
        </th>
        <th class="text-nowrap">
        DATA MOVIMENTO
        </th>  
        
        <th>
         TIPO
        </th>    
        <th class="text-nowrap">
        NUMERO DOCUMENTO
        </th>
        <th class="text-nowrap">
        DATA DOCUMENTO
        </th>
        <th>
        SEDE
        </th>
    
        
      </tr>
    </thead>
    <tbody>
      <tr class="pointer" v-for="(item, index) in filteredItems" :key="index">
        <td>
          {{index+1}}
        </td>
        
        <td class="text-nowrap">
          {{item.supplier}}
        </td>
        <td class="text-right text-nowrap">
            {{fmt2(item.total_qty)}}
        </td>
        <td class="text-right text-nowrap">
            {{fmt1(item.total_value)}}
        </td>
        <td>
          {{item.create_at}}
        </td>
        
        <td class="text-nowrap">
            {{item.description}}
        </td>
          
        <td>
         {{item.number}}
        </td>
        <td>
         {{item.date}}  
        </td>
        <td class="text-nowrap">
            {{item.store}}
        </td>
              
    
      </tr>
    </tbody>
  </table> 
 </div>
</div>

</div>
  <label for="cerca">
  <i style="color:navy" class="fas fa-filter mr-2" aria-hidden="true"></i>  
  <strong>Filtra</strong></label>
  <input class="form-control" type="text" name="query" v-model="filterKey">
 

    
  </div>
</div>


</div>
</div>


</template>

<script>

import api                from '@/api'
import { mapGetters }     from 'vuex'
import fmt                from '@/components/mixins/fmt.js'
import modalMessage       from '@/components/modalDialog/ModalMessage.vue'   

export default {
  mixins:[fmt], 
  

   components: {
     modalMessage
   
  },
  
  data () {
    return {
    
    items          : [],
    filterKey      : '',
    range          : 100

    }
  },
  computed: 
  {  
    ...mapGetters(['company']),
    filteredItems : function () 
      {
        var filterKey = this.filterKey && this.filterKey.toLowerCase()
        var items = this.items
        if (filterKey) {
        items = items.filter(function (row) {
          return Object.keys(row).some(function (key) {
            return String(row[key]).toLowerCase().indexOf(filterKey) > -1
          })
        })
      }
        return items
     },
     

  },
  watch: 
  {
    
  },
      
  mounted()
  {
  
    this.getData()

  },
  created()  
  {
    
  }, 
  methods: 
    {
      
      async getData() 
      {
        const range = this.range
        const sp = 'spSupplierAllDocuments'
        const payload  = {'companyId' : this.company.Id,sp,range}
        
            
        this.$refs.msgModal.show()        
        this.$refs.msgModal.setSpinner(true)  
               
        try{
        
          const res = await api.post(payload)
          if (res.status !== 200) 
          {
            throw new Error(res.data ||  res)
          }
            this.$refs.msgModal.close() 
            this.items = res.data.recordsets[0] 

        }catch(err){

            this.$refs.msgModal.setSpinner(false)
            this.$refs.msgModal.show(err) 
        }
        

      },


      
    },
    
}
</script>

<style scoped>
h4 {
  font-family: 'Roboto Condensed';
  font-size: 18px;
}
p{
  font-family: 'Roboto Condensed';
  font-size: 25px;
}
.my-custom-scrollbar {
position : relative;
height   : 600px;
overflow : auto;
}
.table-wrapper-scroll-y {
display  : block;
}
.table thead  tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;


  
    color       : rgb(16, 16, 15) !important;
    background  : #a9cbe2;
    
    position     : sticky;
    top          : 0;
    z-index      : 10;
    height       : 40px;

 }
a,th{
  font-family : 'Roboto Condensed';
  font-size   : 15px;
 
}


.table th:first-child
{
  border-radius : 0 0 0 8px;
}
.table th:last-child
{
  border-radius : 0 8px 0 0;  
}
.card-header_
{
  height: 45px;
}
.pointer:hover
{
  background-color : blue;
  color            : white;
  cursor           : pointer;
}

.badge-pill
{
    font-size: large;
}
</style>